// Always use absolute URLs based on current origin to work with nginx reverse proxy
// This ensures all requests go through: nginx → API Gateway → microservices
const API_BASE_URL = `${window.location.origin}/api`;

// Create a simple API client similar to axios
class ApiClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  async request(config) {
    const url = `${this.baseURL}${config.url}`;
    const token = localStorage.getItem('authToken');
    
    const headers = {
      'Content-Type': 'application/json',
      ...config.headers
    };

    // Add auth token if available
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const fetchConfig = {
      method: config.method || 'GET',
      headers,
      ...config
    };

    if (config.data) {
      fetchConfig.body = JSON.stringify(config.data);
    }

    try {
      const response = await fetch(url, fetchConfig);
      
      // Handle 401 errors
      if (response.status === 401) {
        console.error('API: Authentication error (401):', url);
        
        // Check if this is an auth endpoint
        if (url.includes('/auth/')) {
          console.log('API: Auth endpoint failed, not redirecting');
          throw new Error(`Request failed with status ${response.status}`);
        }

        // Check if we're already on the login page to avoid redirect loops
        if (window.location.pathname !== '/login') {
          console.log('API: Non-auth endpoint failed with 401, clearing token and redirecting to login');
          
          // Clear the old token
          localStorage.removeItem('authToken');
          localStorage.removeItem('userRole');
          localStorage.removeItem('userName');
          localStorage.removeItem('userEmail');
          
          // Redirect to login page
          window.location.href = '/login';
        }
      }

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return {
        data: await response.json(),
        status: response.status
      };
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async get(url, config = {}) {
    return this.request({ ...config, method: 'GET', url });
  }

  async post(url, data, config = {}) {
    return this.request({ ...config, method: 'POST', url, data });
  }

  async put(url, data, config = {}) {
    return this.request({ ...config, method: 'PUT', url, data });
  }

  async delete(url, config = {}) {
    return this.request({ ...config, method: 'DELETE', url });
  }
}

const api = new ApiClient(API_BASE_URL);

export default api;
